import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpPutService } from 'Feature/Common/Common/Services/OrderHttpService';
import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';
import { AxiosResponse } from 'axios';

import ICancelOrderCommand from '../../Common/types/Commands/ICancelOrderCommand';
import { IGetAllCartItemsByCurrentUserPagedQuery } from '../../Common/types/Queries/IGetAllCartItemsByCurrentUserPagedQuery';

export const getAllCartItemsByCurrentUserPaged = createAsyncThunk(
  'Order/getAllCartItemsByCurrentUserPaged',
  async (query: IGetAllCartItemsByCurrentUserPagedQuery) => {
    return await OrdersHttpGetService({
      url: `${_apiPathManagerConfig?.Orders.Order.GetAllCartItemsByCurrentUserPaged}`,
      params: query,
    });
  }
);
export const cancelOrder = createAsyncThunk('Order/cancelOrder', async (command: ICancelOrderCommand) => {
  return await OrdersHttpPutService({
    url: `${_apiPathManagerConfig?.Orders.Order.CancelOrder}`,
    body: command,

    onResult: (res: AxiosResponse<any, any>): any => {
      return res;
    },
  });
});
